/**
 * Professional Color Palette for MentorCoaching.AI
 *
 * Designed for trust, professionalism, and coaching industry credibility
 * Suitable for 30+ professional coach audience
 */

import { brand } from './tokens';

export const colors = {
  // Primary Brand Colors
  primary: brand.primary,    // Canonical brand blue (D9) - Trust, professionalism
  secondary: '#F59E0B',      // Warm Amber - Energy, growth

  // Status Colors
  success: '#10B981',        // Emerald - Progress, achievement
  warning: '#F59E0B',        // Amber - Attention, feedback
  error: '#EF4444',          // Red - Validation, critical issues
  info: '#3B82F6',           // Blue - Information, neutral

  // Neutral Grayscale
  gray: {
    50: '#F9FAFB',          // Light backgrounds
    100: '#F3F4F6',         // Card backgrounds
    200: '#E5E7EB',         // Borders, dividers
    300: '#D1D5DB',         // Disabled states
    400: '#9CA3AF',         // Muted text, placeholders
    500: '#6B7280',         // Secondary text
    600: '#4B5563',         // Body text
    700: '#374151',         // Dark text
    800: '#1F2937',         // Headers
    900: '#111827',         // Primary text
  },

  // Semantic Color Mappings
  background: '#FFFFFF',
  surface: '#F9FAFB',
  border: '#E5E7EB',

  // Text Colors
  text: {
    primary: '#111827',      // Main headings, important text
    secondary: '#4B5563',    // Body text, descriptions
    muted: '#9CA3AF',        // Captions, metadata
    inverse: '#FFFFFF',      // Text on dark backgrounds
    link: brand.primary,        // Links, interactive text
  },

  // Interactive States
  interactive: {
    hover: `${brand.primary}10`,      // 10% opacity primary
    pressed: `${brand.primary}20`,    // 20% opacity primary
    focus: brand.primary,        // Primary color for focus rings
    disabled: '#F3F4F6',     // Disabled background
  },

  // Professional Gradients
  gradients: {
    primary: [brand.primary, '#3B82F6'],
    secondary: ['#F59E0B', '#FCD34D'],
    success: ['#10B981', '#34D399'],
  },

  // Shadow Colors
  shadow: {
    light: '#00000008',      // Light shadow
    medium: '#00000015',     // Medium shadow
    dark: '#00000025',       // Dark shadow
  },
} as const;

export type Colors = typeof colors;

export default colors;